import { render, staticRenderFns } from "./mail-detail.vue?vue&type=template&id=18af9068&scoped=true"
import script from "./mail-detail.vue?vue&type=script&lang=js"
export * from "./mail-detail.vue?vue&type=script&lang=js"
import style0 from "./mail-detail.vue?vue&type=style&index=0&id=18af9068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af9068",
  null
  
)

export default component.exports